<div class="min-h-screen overflow-x-hidden bg-white font-sans text-[#171923]">
  <app-headerhome></app-headerhome>

  <section class="bg-white px-6 py-14">
    <div class="mx-auto grid max-w-[1100px] grid-cols-1 items-center gap-12 md:grid-cols-2">
      <div>
        <span class="mb-4 inline-flex rounded-full bg-[#fff3c4] px-3.5 py-1.5 text-[13px] font-bold text-[#8a5b00]">{{ parcel.eyebrow || operatorName + ' Parcels' }}</span>
        <h1 class="mb-3.5 font-display text-[32px] font-extrabold leading-[1.15] sm:text-[38px]">{{ parcel.title || 'Door-to-door parcel delivery you can trust' }}</h1>
        <p class="mb-[26px] text-base leading-[1.6] text-muted">{{ parcel.intro || 'Send parcels across our network with confidence, at an affordable price.' }}</p>
        <a class="brand-button focus-ring inline-flex rounded-[10px] px-[26px] py-3.5 text-[15px] font-bold transition hover:brightness-95" [href]="parcelEmailHref">Send an inquiry</a>
      </div>
      <div class="overflow-hidden rounded-[20px] shadow-[0_20px_50px_rgba(16,24,40,.12)]">
        <img class="block w-full object-cover" [src]="parcel.heroImage || 'assets/images/parcel2.webp'" [alt]="operatorName + ' parcel delivery service'">
      </div>
    </div>
  </section>

  <section class="px-6 py-[72px]">
    <div class="mx-auto max-w-[900px]">
      <h2 class="mb-[18px] text-center font-display text-[26px] font-extrabold">{{ parcel.featuresTitle || 'Why ship with ' + operatorName }}</h2>
      <p class="mx-auto mb-11 max-w-[640px] text-center text-[15.5px] leading-7 text-muted">{{ parcel.featuresIntro || 'Our parcel service is committed to a trustworthy, user-friendly delivery experience at an affordable price.' }}</p>
      <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
        @for (feature of features; track feature) {
          <div class="flex items-start gap-3.5">
            <span class="brand-icon grid size-[38px] shrink-0 place-items-center rounded-[10px] bg-[#fce3e1]">
              <svg class="size-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>
            </span>
            <p class="pt-2 text-[15px] text-[#3f4552]">{{ feature }}</p>
          </div>
        }
      </div>
    </div>
  </section>

  <section class="px-6 pb-[90px]">
    <div class="mx-auto max-w-[900px] rounded-3xl bg-[#171923] p-8 text-center sm:p-11">
      <h2 class="mb-2.5 font-display text-[22px] font-extrabold text-white">Need to send a parcel today?</h2>
      <p class="mb-[22px] text-[15px] text-white/70">Reach our parcel desk and we'll take it from there.</p>
      <a class="focus-ring inline-flex max-w-full rounded-[10px] bg-white px-[26px] py-3.5 text-[15px] font-bold text-[#171923]" [href]="parcelEmailHref">{{ parcelEmail }}</a>
    </div>
  </section>

</div>
